import { BaseContainerModel } from '../base-container.model';
import { bl_hc_medicine_hdr_RowClass, bl_hc_medicine_hdr_RowInterface } from '../../dbschema/bl_hc_medicine_hdr.model';


export class HcMedicineHdrContainerModel extends BaseContainerModel {
  bl_hc_medicine_hdr: bl_hc_medicine_hdr_RowInterface = new bl_hc_medicine_hdr_RowClass();
}